<template>
<div class="chapter">
<div class="inner_page">
<h1 class="ch-title">TAMING CHAOS <br/>WORKBOOK</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?004653e9